<template>
    <div class="pageInfo">
        <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                 label-width="120px">
            <el-form-item label="所属部门">
                <el-input style="width:200px" v-model="form.departmentNameBill" readonly></el-input>
            </el-form-item>
            <el-form-item label="计划编号">
                <el-input style="width:200px" v-model="form.billNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="单据日期">
                <el-input style="width:200px" v-model="form.billDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="项目名称">
                <el-input style="width:200px" v-model="form.projectName" readonly></el-input>
            </el-form-item>
            <el-form-item label="客户">
                <el-input style="width:200px" v-model="form.customerName" readonly></el-input>
            </el-form-item>
            <el-form-item label="联系人">
                <el-input style="width:200px" v-model="form.contactName" readonly></el-input>
            </el-form-item>

            <el-form-item label="联系方式">
                <el-input style="width:200px" v-model="form.contactTel" readonly></el-input>
            </el-form-item>
            <el-form-item label="订单编号">
                <el-input style="width:200px" v-model="form.relaBillNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="业务员">
                <el-input style="width:200px" v-model="form.salesMan" readonly></el-input>
            </el-form-item>

            <el-form-item label="订单金额">
                <el-input style="width:200px" v-model="form.taxTotal" readonly></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input style="width:200px" v-model="form.remark" readonly></el-input>
            </el-form-item>
        </el-form>

        <div style="padding-top: 20px">
            <el-table
                    ref="table"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    row-key="id"
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    border>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="payCondition"
                        width="200"
                        label="支付条件">
                </el-table-column>
                <el-table-column
                        prop="payNodes"
                        width="150"
                        label="支付节点">
                </el-table-column>
                <el-table-column
                        prop="payRate"
                        width="150"
                        label="支付比例">
                </el-table-column>
                <el-table-column
                        prop="payTotal"
                        width="150"
                        label="支付金额">
                </el-table-column>
                <el-table-column
                        prop="planPayDate"
                        width="120"
                        label="预计支付日期">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备注">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoPage",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

                dataList:[],
                pageInfo: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
            };
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/collectionplan/listProduct",
                    param: {
                        billId:this.form.billId,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.data;
                    this.pageInfo.total = data.data.count;
                }
                this.dataList.map(item=>{
                    item._edit = true
                })
                this.dialoading = false;
            },

            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>


